module.exports = __webpack_public_path__ + "../assets/img/d9bf9f66d3ef9bf4809c91bc551ff9fc.svg";